// extracted by mini-css-extract-plugin
module.exports = {"content":"content--_4WA8KXt"};